import type { Icon } from '../../../src/lib/types'
export const mdiFormatAlignCenter: Icon = {
  "id": "format-align-center",
  "name": "Format Align Center",
  "path": "M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z",
  "as": [
    "format-align-centre"
  ],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatAlignCenter